export default __webpack_public_path__ + "assets/images/callback-winter-3a1c43ed.png";